import { Icon } from "common/LegacyIcon";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import { Link } from "react-router-dom";
import styles from "./Messages.scss";

export const errorMessage = (
  <div className={styles.infoMessage}>
    <Icon i="farthingWithFlat" size={300} />
    <h3>
      <T id="Messages.bummer" defaultMessage="Bummer" />
    </h3>
    <p>
      <T
        id="Messages.troubleLoading"
        defaultMessage="We had some trouble loading this page for you. Try refreshing the page, and if you still get this message don't hesitate to <a>get in touch</a>."
        values={{
          a: (...c) => <a href="https://ridewithgps.zendesk.com/hc/en-us/requests/new">{c}</a>,
        }}
      />
    </p>
  </div>
);

export const noReportsMessage = (
  <div className={styles.infoMessage}>
    <div className={styles.multibike}>
      <Icon i="rwgps" size={50} />
      <Icon i="rwgps" size={50} />
      <Icon i="rwgps" size={50} />
      <Icon i="rwgps" size={50} style={{ opacity: 0.25 }} />
      <Icon i="rwgps" size={50} />
    </div>
    <h3>
      <T id="Messages.nothing" defaultMessage="Nothing to see here" />
    </h3>
    <p>
      <T
        id="Messages.noRR"
        defaultMessage="There are no ride reports to show for this page. Perhaps you should <a>write one</a>?"
        values={{ a: (...c) => <Link to="/ride_reports/new">{c}</Link> }}
      />
    </p>
  </div>
);
